import React from 'react';
import PropTypes from 'prop-types';
import CounterFeature from "../../Counter";
import TimerFeature from "../../Timer";
import CounterButtonsProvider from "../../CounterButtons";
import {Grid, Typography} from "@material-ui/core";

const CounterCentralTimer = ({ workoutGroup, groupID, workoutPartID }) => {
    const workoutPath = `/workout/${workoutGroup}/${groupID}/${workoutPartID}`
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant={'h1'} align={"right"}>
                        <CounterFeature
                            workoutPath={workoutPath}
                        />
                    </Typography>
                    <Typography variant={'h3'} align={"right"}>
                        <TimerFeature
                            display
                            path={`/timer/${workoutGroup}`}
                        />
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <CounterButtonsProvider workoutPath={workoutPath} amount={1}/>
                </Grid>
                <Grid item xs={12}>
                    <CounterButtonsProvider workoutPath={workoutPath} amount={5}/>
                </Grid>
                <Grid item xs={12}>
                    <CounterButtonsProvider workoutPath={workoutPath} amount={10}/>
                </Grid>
            </Grid>
        </>
    );
}

CounterCentralTimer.propTypes = {}

export default CounterCentralTimer;
